var map = {
	"./1_0000.jpg": "ua7E",
	"./1_0001.jpg": "IDlb",
	"./1_0002.jpg": "tIk2",
	"./1_0003.jpg": "XzzE",
	"./1_0004.jpg": "rkoK",
	"./1_0005.jpg": "JgrF",
	"./1_0006.jpg": "LQ5J",
	"./1_0007.jpg": "VObn",
	"./1_0008.jpg": "4f6u",
	"./1_0009.jpg": "MjC4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bii8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech ^\.\/1_000.*\.jpg$
// module id = bii8
// module chunks = 0